import { render } from "./lazy-load.vue?vue&type=template&id=305905e4&scoped=true&ts=true"
import script from "./lazy-load.vue?vue&type=script&lang=ts"
export * from "./lazy-load.vue?vue&type=script&lang=ts"

import "./lazy-load.vue?vue&type=style&index=0&id=305905e4&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305905e4"]])

export default __exports__